import React from 'react';
import ReferralDetail from '../components/partner-network/ReferralDetail';

const ReferralDetailPage: React.FC = () => <ReferralDetail />;

export default ReferralDetailPage;
